import React from 'react';
import { PieChart, Pie, Legend, Cell, Tooltip, ResponsiveContainer } from 'recharts';

import { screenWidth } from '../../Constants';
import DownloadChartButton from '../Buttons/DownloadChartButton';
import { theme } from '../../tailwind.config';
import CustomizedLabel from './CustomizedLabel';
import useInputContext from '../../hooks/useInputContext';
import { useChartData } from '../../hooks/useChartData';
import Loading from '../general/Loading';
import { CustomTooltipPiechart } from '../../helpers/CustomizedTooltip';
import { renderLegend } from '../../helpers/renderLegend';

const COLORS = [
  theme.colors['micro-grid'],
  theme.colors['micro-solar'],
  theme.colors['micro-genset-curtailed'],
  theme.colors['micro-min-soc'],
  theme.colors['micro-max-soc'],
  theme.colors['micro-solar-battery'],
  theme.colors['micro-generator-not-used'],
  theme.colors['micro-battery-supply'],
];

/**
 * The GensetRunningHours component
 *
 * @return {JSX.Element}
 */
export default function GensetRunningHours() {
  const { runId } = useInputContext();
  const { data, isLoading, isError, error } = useChartData(runId, 'genset_running_hours');
  const chartName = 'Genset Running Hours';
  const elements = document.querySelector('#genset-running-chart');

  return (
    <>
      <div className="chart-container">
        <div className="flex items-center justify-between pb-8">
          <h2 className="text-xl uppercase">{chartName}</h2>
          {!isLoading && !!data.length && (
            <DownloadChartButton isLoading={isLoading} name={chartName} elements={elements} />
          )}
        </div>
        {isLoading ? (
          <Loading />
        ) : isError ? (
          <p>{error}</p>
        ) : (
          <ResponsiveContainer height={screenWidth <= theme.screens.md.value ? 300 : 500}>
            <PieChart>
              <Pie
                dataKey="value"
                isAnimationActive={true}
                data={data}
                labelLine={false}
                paddingAngle={0}
                label={<CustomizedLabel fill={theme.colors.black} />}
              >
                {/* maps over the data object and returns the piece of the pie chart in the right color */}
                {data.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                ))}
              </Pie>
              <Tooltip content={<CustomTooltipPiechart />} />
              <Legend
                formatter={renderLegend}
                align="center"
                verticalAlign="bottom"
                layout="horizontal"
              />
            </PieChart>
          </ResponsiveContainer>
        )}
      </div>
    </>
  );
}
